import cx from 'classnames';
import React, {useState, useEffect} from 'react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Scrollbar} from '@priority-software/priority-style-react';
import {ContentHeader} from './ContnetHeader';
import {EmptyState} from './EmptyState';
import {ShowMoreRow} from './ShowMoreRow';
import {ListItem} from './ListItem/ListItem';
import {getTooltipPosition, MandatoryColIds} from '../utils';
import {MAX_LOAD, CONTENT_CONTAINER_ID} from '../consts';
import styles from '../styles/ToDoListConent.module.scss';
import {isRTL} from '../../../Localization';
import {ISort} from '../../../stores/Form/Sort';
import {Record} from '../../../stores/Form/Record';

export const ToDoListContent = ({
    mandatoryColIds,
    viewCols,
    records,
    sortedCol,
    onSort,
    getStatusList,
    saveUpdate,
    openToDoListScreen,
    updateTaskStatus,
    updatePriorityField,
    formName
}: {
    mandatoryColIds: MandatoryColIds;
    viewCols: priority.netitems.form.IColumn[];
    records: Record[];
    sortedCol: ISort;
    onSort: (viewCol: priority.netitems.form.IColumn) => void;
    getStatusList: (record: Record) => Promise<priority.netitems.form.ISelectValues[]>;
    saveUpdate: () => void;
    openToDoListScreen: () => void;
    updateTaskStatus: (value: string) => void;
    updatePriorityField: (record: Record, value: string) => void;
    formName: string;
}) => {
    const [isScrollbarDisabled, setIsScrollbarDisabled] = useState(false);

    useEffect(() => {
        const container = document.getElementById(CONTENT_CONTAINER_ID);
        const handler = e => {
            e.stopPropagation();
            e.stopImmediatePropagation();
        };
        container?.addEventListener('wheel', handler, {passive: false});
        return container?.removeEventListener('wheel', handler);
    }, []);

    const dirRtl = isRTL();

    return (
        <div id={CONTENT_CONTAINER_ID} className={styles.ContentContainer}>
            <ContentHeader viewCols={viewCols} sortedCol={sortedCol} onSort={onSort} />
            {records.length > 0 && (
                <div className={styles.tableList}>
                    <Scrollbar
                        autoHeight={true}
                        autoHeightMax={210}
                        componentClasses={cx(styles.scrollbarContainer, {
                            [styles.disabled]: isScrollbarDisabled
                        })}
                        rtl={dirRtl}
                    >
                        {records.map((rec, idx) => {
                            if (idx >= MAX_LOAD) {
                                return (
                                    <ShowMoreRow
                                        openToDoListScreen={openToDoListScreen}
                                        formName={formName}
                                        key={idx}
                                    />
                                );
                            } else {
                                return (
                                    <ListItem
                                        record={rec}
                                        mandatoryColIds={mandatoryColIds}
                                        viewCols={viewCols}
                                        key={idx}
                                        getStatusList={getStatusList}
                                        saveUpdate={saveUpdate}
                                        updateTaskStatus={updateTaskStatus}
                                        setIsScrollbarDisabled={setIsScrollbarDisabled}
                                        updatePriorityField={updatePriorityField}
                                        tooltipPosition={getTooltipPosition()}
                                    />
                                );
                            }
                        })}
                    </Scrollbar>
                </div>
            )}
            {records.length === 0 && <EmptyState />}
        </div>
    );
};
